import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlane, FaHotel, FaUmbrella, FaPassport, FaGlobeAmericas } from 'react-icons/fa';
import Loader from '../components/Loader';
import UnifiedStarBackground from '../components/UnifiedStarBackground';
import { supabase } from '../config/supabaseClient';
import '../styles/Login.css';

const SignUp: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !password || !confirmPassword) {
      setError('Please fill in all fields');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      setIsLoading(true);
      setError('');
      
      console.log('Starting signup process...');
      const { data, error: signUpError } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            email: email
          }
        }
      });

      if (signUpError) {
        console.error('Signup error:', signUpError);
        throw signUpError;
      }

      console.log('Auth signup response:', data);

      if (data?.user) {
        // Show success message and direct to login
        setError('');
        console.log('Signup successful! Please check your email for verification.');
        navigate('/login');
      } else {
        console.error('No user data received after signup');
        throw new Error('Failed to create user account');
      }
    } catch (error) {
      setError(error instanceof Error ? error.message : 'An error occurred during sign up');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="login-container">
        <UnifiedStarBackground variant="primary" />
        <div className="travel-icons">
          <FaPlane className="travel-icon" />
          <FaHotel className="travel-icon" />
          <FaGlobeAmericas className="travel-icon main-icon" />
          <FaUmbrella className="travel-icon" />
          <FaPassport className="travel-icon" />
        </div>
        <div className="login-box">
          <h2>
            <span className="title-trip">Trip</span>
            <span className="title-go">Go</span>
          </h2>
          <p className="subtitle">Create Your Account</p>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm your password"
                required
              />
            </div>
            <button type="submit" className="login-button">
              Sign Up
            </button>
          </form>
          <p className="signup-link">
            Already have an account? <a href="/login">Login</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default SignUp;